var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonEmpathy = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 49", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { clipPath: "url(#icon-empathy_svg__clip0_403_3090)" },
            React.createElement("path", { d: "M8.83 16.096a7.868 7.868 0 117.867 7.868 7.845 7.845 0 01-7.868-7.868z", fill: fills.base }),
            React.createElement("path", { d: "M6.497 29.641a8.433 8.433 0 016.007-2.497h8.363a8.528 8.528 0 016.03 2.497 8.622 8.622 0 012.498 6.031v1.696a3.416 3.416 0 01-3.416 3.416H7.416A3.416 3.416 0 014 37.368v-1.696a8.528 8.528 0 012.497-6.03z", fill: fills.light }),
            React.createElement("path", { d: "M42.68 19.04a4.546 4.546 0 00-6.407 0l-.871.872-.778-.8c-1.743-1.744-4.57-1.862-6.36-.189a4.523 4.523 0 00-.118 6.502l.872.871 6.054 6.055a.495.495 0 00.683 0l6.054-6.055.872-.871a4.5 4.5 0 000-6.384z", fill: fills.dark })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "icon-empathy_svg__clip0_403_3090" },
                React.createElement("path", { fill: "#fff", transform: "translate(4 8.228)", d: "M0 0h40v32.556H0z" })))));
}, {
    name: identiconComponentName,
})({});
